import Container from "Components/Container/Container";
import Navigation from "./Navigation";
import Logo from "./Logo";
import AuthenticationButton from "./AuthenticationButton";
import Cart from "./Cart";
import LanguageSelector from "Components/LanguageSelector/LanguageSelector";
import { WebinarButton } from "Components/Webinar";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { t } = useTranslation();

  // Prevent scrolling when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [mobileMenuOpen]);

  // Function to close menu when navigating
  const closeMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className=" lg:pt-4 lg:pt-6 lg:pt-8 font-text relative z-50">
      {/* Desktop header - hidden on mobile */}
      <div className="hidden lg:block">
        <Container>
          <div className="flex items-center justify-between">
            <div className="flex-1 flex items-center gap-2">
              <LanguageSelector />
              <WebinarButton />
            </div>
            <Logo />
            <div className="flex-1 flex items-stretch gap-x-2 justify-end">
              <Cart />
              <AuthenticationButton />
            </div>
          </div>
          {/* Desktop Navigation */}
          <div>
            <Navigation />
          </div>
        </Container>
      </div>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300 ${
          mobileMenuOpen ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
        onClick={() => setMobileMenuOpen(false)}
      ></div>

      {/* Mobile Menu Drawer */}
      <div
        className={`lg:hidden fixed inset-y-0 right-0 w-full bg-white z-40 transform transition-transform duration-300 ease-in-out ${
          mobileMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <Container className="h-full flex flex-col pt-20 pb-8">
          {/* Close button */}
          <button
            className="absolute top-4 right-4 p-2 rounded-full bg-gray-100 hover:bg-gray-200"
            onClick={() => setMobileMenuOpen(false)}
            aria-label={t("common.close")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          <div className="mb-8 text-center">
            <Logo />
          </div>

          <div className="flex-grow overflow-y-auto">
            <Navigation closeMenu={closeMenu} isMobileView={true} />
          </div>

          <div className="mt-6 pt-6 border-t border-gray-200">
            <div className="flex flex-col gap-4">
              <div className="flex flex-wrap items-stretch justify-center gap-x-4 mt-2 gap-y-2">
                <LanguageSelector onClick={closeMenu} />
                <WebinarButton onClick={closeMenu} />
                <Cart onClick={closeMenu} />
                <AuthenticationButton onClick={closeMenu} />
              </div>
            </div>
          </div>
        </Container>
      </div>

      {/* Hamburger Menu Button - Mobile Only */}
      <Container>
        <div className="lg:hidden flex items-center justify-between border-b border-primary py-4">
          <div className="flex items-center justify-between">
            <Logo />
          </div>
          <button
            className=" p-2 bg-white rounded-full shadow-lg"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={
              mobileMenuOpen ? t("common.closeMenu") : t("common.openMenu")
            }
          >
            {mobileMenuOpen ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            )}
          </button>
        </div>
      </Container>
    </header>
  );
};

export default Header;
